import { forEach } from 'lodash';

export const selector = 'dbStopPropagation';

/* @ngInject */
export default function StopPropagationDirective() {
    return {
        restrict: 'A',
        
        link: (scope, element, attrs) => {
            let events = String.prototype.split.call(attrs[selector] || '', ' ');

            forEach(events, (event) => element.on(event, handlePropagation));

            scope.$on('$destroy', () => {
                forEach(events, (event) => element.off(event, handlePropagation));
            });

            function handlePropagation(event) {
                event.stopPropagation();
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/common/directive/stop-propagation/stop-propagation.directive.js